import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Box, TextField, Typography } from '@material-ui/core';
import {
    getRequestingResetEmail,
    getRequestResetEmailSuccess,
    getRequestResetEmailSuccessEmail,
} from '€slices/password-reset/password-reset-selectors';
import { requestResetEmail } from '€slices/password-reset';
import PreAuthLayout from '€layouts/PreAuthLayout';
import ContentLayout from '€layouts/ContentLayout';
import MetaLayout from '€layouts/MetaLayout';
import PrimaryButton from '€components/PrimaryButton';
import { Routes } from '€lib/routing';
import CenterSmUp from '€components/CenterSmUp';
import MuiRouterLink from '€components/MuiRouterLink';

const PasswordRecovery = () => {
    const { register, handleSubmit, setError } = useForm();

    const emailSuccess = useSelector(getRequestResetEmailSuccess);
    const emailSuccessEmail = useSelector(getRequestResetEmailSuccessEmail);
    const requesting = useSelector(getRequestingResetEmail);
    const dispatch = useDispatch();
    const router = useRouter();

    const onSubmit = useCallback(
        async ({ username }) => {
            try {
                await dispatch(requestResetEmail({ username }));
            } catch (e) {
                setError('username', { type: 'manual', message: e.message });
            }
        },
        [dispatch, setError],
    );

    return (
        <>
            <MetaLayout metaTitle="Loan | Login">
                {!emailSuccess && (
                    <PreAuthLayout
                        title="Let's reset your password"
                        subtitle="What email address do you use for your Loan account?"
                    >
                        <Box my={4}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <ContentLayout.Form>
                                    <ContentLayout.FormField>
                                        <TextField
                                            required
                                            inputRef={register({ required: '* required' })}
                                            type="email"
                                            name="username"
                                            label="Email Address"
                                            autoFocus
                                        />
                                    </ContentLayout.FormField>
                                    <ContentLayout.Action>
                                        <Box display="flex" justifyContent="center">
                                            <PrimaryButton
                                                size={['full', 'large']}
                                                disabled={requesting}
                                                type="submit"
                                            >
                                                Confirm
                                            </PrimaryButton>
                                        </Box>
                                    </ContentLayout.Action>
                                    <Box textAlign="center" pt={2}>
                                        <MuiRouterLink to={Routes.Login}>
                                            Sign in, instead?
                                        </MuiRouterLink>
                                    </Box>
                                </ContentLayout.Form>
                            </form>
                        </Box>
                    </PreAuthLayout>
                )}
                {emailSuccess && (
                    <PreAuthLayout title="Password Reset">
                        <ContentLayout.Section>
                            <CenterSmUp>
                                <Typography component="p">
                                    We have sent you a password reset email to {emailSuccessEmail}
                                </Typography>
                            </CenterSmUp>
                        </ContentLayout.Section>
                        <CenterSmUp>
                            <Typography component="p">
                                Once it arrives (check your spam folder) follow the instructions to
                                reset your password
                            </Typography>
                        </CenterSmUp>
                        <ContentLayout.Action>
                            <Box display="flex" justifyContent="center">
                                <PrimaryButton
                                    style={{ textDecoration: 'none' }}
                                    size={['full', 'large']}
                                    component={MuiRouterLink}
                                    to={Routes.Login}
                                >
                                    Back to Sign In
                                </PrimaryButton>
                            </Box>
                        </ContentLayout.Action>
                    </PreAuthLayout>
                )}
            </MetaLayout>
        </>
    );
};

export default PasswordRecovery;
